module.exports = __webpack_public_path__ + "img/source04_6.29e811ff.png";